export default function isFiniteNumber(value) {
    return typeof value === 'number' && value > -Infinity && value < Infinity;
}
